// Import dependencies
import initialiser from '../../utils/initialiser';

const defaultSettings = {
  calendarOpenClass: 'is-open',
  calendarOpenClassBody: 'has-calendar-open',
  menuOpenClassBody: 'has-menu-open',
};

class Calendar {
  constructor(config) {
    const { el, settings } = config;

    // Set root element
    this.container = el;
    this.trigger = document.querySelector(settings.trigger);
    this.triggerMobile = document.querySelector(settings.triggerMobile);
    this.containerInner = el.querySelector(settings.containerInner);
    this.mediaQuery = window.matchMedia(`(min-width: ${settings.mediaQuery}px)`).matches;

    // Set settings
    this.settings = { ...defaultSettings, ...settings };
  }

  // Initialisation Function - Called on each component instance intialisation
  init = () => {
    if (!this.container || !this.trigger || !this.triggerMobile || !this.containerInner) return;

    // Call bind events
    this.bindEvents();
  };

  bindEvents = () => {
    window.addEventListener('load', this.handleCalendarUrlHash);
    window.addEventListener('hashchange', this.handleSecondCalendarUrlHash);

    if (!this.mediaQuery) {
      this.triggerMobile.addEventListener('click', this.handleCalendarToggle);
      return;
    }

    this.trigger.addEventListener('click', this.handleCalendarToggle);
  };

  handleCalendarUrlHash = () => {
    if (window.location.hash === '#calendar') {
      this.handleCalendarToggle();
    }

    return false;
  };

  handleSecondCalendarUrlHash = () => {
    if (window.location.hash === '#whatson') {
      this.handleCalendarToggle();
    }

    return false;
  };

  handleCalendarToggle = () => {
    this.container.classList.toggle(this.settings.calendarOpenClass);
    document.body.classList.toggle(this.settings.calendarOpenClassBody);

    if (!this.mediaQuery) {
      if (this.container.classList.contains(this.settings.calendarOpenClass)) {
        document.querySelector('.c-header__chief-conductor-container').classList.add('u-hide');
      } else {
        document.querySelector('.c-header__chief-conductor-container').classList.remove('u-hide');
      }

      document.querySelector('.c-header').classList.remove('menu-opened');
    }

    if (document.body.classList.contains(this.settings.menuOpenClassBody)) {
      document.body.classList.remove(this.settings.menuOpenClassBody);
    }

    if (document.querySelector('.c-banner--announcements')) {
      document.querySelectorAll('.js-cookies').forEach(banner => banner.classList.remove('is-open'));
    }
  };
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, Calendar);
